// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';
import { ButtonExtraLargeLayout } from '../common/buttons/ButtonExtraLargeLayout';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 0.9,
        y: 0.9
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '4722bc05-9273-4c6f-9cab-dcfc214ccb17',
      type: 'Container',
      name: 'header',
      className: '',
      x: 0,
      y: -492,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'b3cda4eb-1094-4dc0-b332-593d26ba1488',
      type: 'Container',
      name: 'upsellContainer',
      className: '',
      x: 0,
      y: -380,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'a051caaa-a465-4fc3-b5a3-c7ab7e350440',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Red_Header',
      parent: '4722bc05-9273-4c6f-9cab-dcfc214ccb17'
    },
    {
      id: 'e0aac306-e43d-4861-8f1e-76fcf978bb17',
      type: 'Sprite',
      name: 'closeButton',
      className: '',
      x: 210,
      y: -77,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      texture: 'Close_Button',
      parent: '4722bc05-9273-4c6f-9cab-dcfc214ccb17'
    },
    {
      id: 'c13c0a03-36e1-4ac0-9cf1-8fb8cff83d01',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: -10,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'OUT OF COINS!',
      localize: true,
      maxWidth: 412,
      maxHeight: 177,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 46,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#840025',
        strokeThickness: 8,
        align: 'left',
        wordWrap: true,
        wordWrapWidth: 405,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '4722bc05-9273-4c6f-9cab-dcfc214ccb17'
    },
    {
      id: '505f6561-02b0-4b90-a270-cd273d3c4272',
      type: 'Container',
      name: 'upsellSlot',
      className: '',
      x: 0,
      y: 410,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'b3cda4eb-1094-4dc0-b332-593d26ba1488'
    },
    {
      id: 'f5236178-6d25-40ab-8978-4fdc6ff28de1',
      type: 'Container',
      name: 'moreOffersButton',
      className: '',
      x: 0,
      y: 899,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'None'
      },
      parent: 'b3cda4eb-1094-4dc0-b332-593d26ba1488'
    },
    {
      id: '66a86647-17ee-4949-a027-52e4d0c78d80',
      type: 'Layout',
      name: '',
      className: '',
      path: 'common/buttons/ButtonExtraLargeLayout.ts',
      percentX: 0,
      percentY: 0,
      handleResize: false,
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: 'f5236178-6d25-40ab-8978-4fdc6ff28de1',
      data: {
        color: 'blue',
        tapSound: 'UI_Button_Click'
      }
    },
    {
      id: 'b3b33266-49a6-40cc-84bd-55c1e0b75322',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'See More Offers',
      localize: true,
      maxWidth: 312,
      maxHeight: 145,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#0047b3',
        strokeThickness: 7,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'f5236178-6d25-40ab-8978-4fdc6ff28de1'
    }
  ],
  x: 0,
  y: 0,
  width: 780,
  height: 1280,
  version: '1.0.0',
  handleResize: false
} as const;

export class UpsellPopupLayout {
  static raw = raw;
  root!: Container;
  header!: Container;
  upsellContainer!: Container;
  closeButton!: Sprite;
  upsellSlot!: Container;
  moreOffersButton!: Container;
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
